import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const KCPPayment = () => {
  return <CommonProcess />;
};

export default KCPPayment;
